// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5943) return "static/chunks/5943-69ddced8e6bf95db.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1106 ? "13adf9a2" : chunkId) + "." + {"668":"2f9d3e9c0b906f36","1106":"fc6e089661970035","8287":"e5c40294533b8b1d"}[chunkId] + ".js";
};